import { ApplyChartTemplateToDoc } from "./ApplyChartTemplateToDoc";
import { ShouldApplyToSubCharts } from "./ShouldApplyToSubCharts";
import { DoOptimizePages } from "./DoOptimizePages";

export function ApplyChartTemplateToDocMgr(
  theTemplate,
  wsMgr,
  boxStyleMgr,
  currentDoc,
  doOptimize
) {
  if (wsMgr.fCanvasPanel) {
    //Active text edits
    wsMgr.fCanvasPanel.ClearSelection();
  }

  var docMgr = wsMgr.GetDocMgr();
  var numDocs = docMgr.GetNumDocuments();

  var boxList = wsMgr.GetTargetTrees(false, currentDoc, true);
  var applyToSubCharts = ShouldApplyToSubCharts(boxList, currentDoc);
  ApplyChartTemplateToDoc(currentDoc, theTemplate, boxList, applyToSubCharts, wsMgr);

  if (!applyToSubCharts) return;

  applyToSubCharts = -2;
  for (var j = 0; j < numDocs; j++) {
    var targetDoc = docMgr.GetIndexDoc(j);
    var divName = targetDoc.GetDivisionName();
    if (currentDoc != targetDoc)
      ApplyChartTemplateToDoc(targetDoc, theTemplate, null, applyToSubCharts, wsMgr);
  }

  if (doOptimize) DoOptimizePages(wsMgr);
}
